import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store';
import { AsyncState } from '../common/Utils';
import { CheckHistory } from '../api/DomainTypes';
import { useEffect, useMemo } from 'react';
import { ParamDataListTypes } from '../types';
import { typeIdsToObjectiveStatusName } from '../constants/default';
import { SagaActionType } from '../store/sagas/sagaActions';

const urlPattern = new RegExp(
  '^(https?:\\/\\/)?' + // protocol
  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
  '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
  '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
  '(\\#[-a-z\\d_]*)?$',
  'i'
);

function isValidUrl(str: string) {
  return urlPattern.test(str);
}

// @ts-ignore
const useCheckHistory: () => AsyncState<ParamDataListTypes> = () => {
  const checkHistoryState = useSelector<RootState, AsyncState<CheckHistory> | undefined>(state => {
    // @ts-ignore
    return state.chat.currentCheckHistory;
  });
  const dispatch = useDispatch();


  const stateExist = !!checkHistoryState?.value;

  useEffect(() => {
    if (!stateExist) {
      dispatch({ type: SagaActionType.START_LOAD_CHECK_HISTORY });

    }
  }, [dispatch, stateExist]);

  return useMemo(() => {
    if (checkHistoryState?.value) {
      const result: ParamDataListTypes = {
        height: null,
        weight: null,
        pressure: null,
        consciousness: null,
        pulse: null,
        respiratoryRate: null,
        saturation: null,
        temperature: null,
        feces: null,
        urination: null,
        excrementPhoto: null,
      };
      const newResult = checkHistoryState?.value?.messages.reduce((previousValue, currentValue) => {
        const name = typeIdsToObjectiveStatusName[currentValue.anamnesisId];

        if (isValidUrl(currentValue.value)) {
          // @ts-ignore
          previousValue[name] = { image: currentValue.value };
        } else {
          // @ts-ignore
          previousValue[name] = { text: currentValue.value };
        }

        return previousValue;
      }, result);
      return { ...checkHistoryState, value: newResult };
    } else {
      return checkHistoryState;
    }
  }, [checkHistoryState]);
};

export default useCheckHistory;
